import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { LoadingModalService } from '@app/shared/services/loading-modal.service';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss',
    imports: [MatButton, RouterLink, TranslocoDirective],
})
export class ErrorComponent {
    private loading = inject(LoadingModalService);

    constructor() {
        this.loading.hideLoader();
    }
}
